import React, { useContext } from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import slugify from 'slugify'
import { useTheme, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Layout from '../../../components/Layout'
import FontContext from '../../../context/fontsize/fontContext'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import PostsLists from '../../../components/PostsList'
import Seo from '../../../components/Seo'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'

import setupTags from '../../../utils/setupTags'

const query = graphql`
	{
		allContentfulBlogPost {
			nodes {
				id
				title
				shortTitle
				createdAt(formatString: "MMM d")
				featured
				tags {
					tags
				}
				body {
					body
				}
				image {
					gatsbyImageData(
						layout: CONSTRAINED
						placeholder: DOMINANT_COLOR
						width: 152
					)
				}
			}
		}
	}
`

const useStyles = makeStyles((theme) => ({
	outerCtr: {
		// paddingLeft: 100,
		marginLeft: 'auto',
		marginRight: 'auto',
		[theme.breakpoints.down('md')]: {
			paddingLeft: 75,
		},
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 50,
		},
		[theme.breakpoints.down('xs')]: {
			padding: '1.25em',
		},
	},
	title: {
		color: theme.palette.common.accent,
		fontSize: '1rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	lightTitle: {
		color: theme.palette.common.accent,
		fontSize: '1rem',
		fontWeight: 700,
		[theme.breakpoints.up('sm')]: {
			fontWeight: 500,
		},
	},
	shortTitle: {
		color: 'lightgrey',
	},
	lightShortTitle: {
		color: 'rgba(117, 117, 117, 1)',
	},
	tags: {
		color: '#f2f2f2',
		fontSize: '.8rem',
		marginBottom: 3,
		fontWeight: 400,
		textDecoration: 'none',
		textTransform: 'capitalize',
	},
	lightTags: {
		color: '#292929',
		fontSize: '.8rem',
		marginBottom: 3,
		fontWeight: 400,
		textDecoration: 'none',
		textTransform: 'capitalize',
	},
	date: {
		color: 'lightgrey',
		fontSize: '.8rem',
	},
	lightDate: {
		color: '#757575',
		fontSize: '.8rem',
	},
	gatsImage: {
		[theme.breakpoints.down('xs')]: {
			width: 100,
		},
	},
	breadcrumb: {
		color: 'grey',
		fontSize: '.9rem',
		fontWeight: 400,
		textDecoration: 'none',
		textTransform: 'capitalize',
	},
	lightBreadcrumb: {
		color: '#292929',
		fontSize: '.9rem',
		fontWeight: 400,
		textDecoration: 'none',
		textTransform: 'capitalize',
	},
	crumbCtr: {
		// paddingBottom: '1em',
	},
}))

export default function CategoriesIndex({ data }) {
	const {
		allContentfulBlogPost: { nodes: posts },
	} = useStaticQuery(query)

	const classes = useStyles()
	const theme = useTheme()
	const fontContext = useContext(FontContext)
	const { darkMode } = fontContext

	const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))

	const newTags = setupTags(posts)

	return (
		<Layout>
			<Seo title='Categories' />
			<Grid container className={classes.outerCtr} justify='center'>
				{/* <Grid item xs={12}>
					<Breadcrumbs aria-label='breadcrumb' className={classes.crumbCtr}>
						<Link
							to='/articles/'
							className={
								darkMode ? classes.breadcrumb : classes.lightBreadcrumb
							}
						>
							Articles
						</Link>
						<Link
							to='#!'
							className={
								darkMode ? classes.breadcrumb : classes.lightBreadcrumb
							}
							style={{ fontWeight: 500 }}
						>
							Categories
						</Link>
					</Breadcrumbs>
				</Grid> */}
				<Grid item>
					<Grid container direction='column' spacing={3}>
						<Grid item xs={12}>
							<Breadcrumbs aria-label='breadcrumb' className={classes.crumbCtr}>
								<Link
									to='/articles/'
									className={
										darkMode ? classes.breadcrumb : classes.lightBreadcrumb
									}
								>
									Articles
								</Link>
								<Link
									to='#!'
									className={
										darkMode ? classes.breadcrumb : classes.lightBreadcrumb
									}
									style={{ fontWeight: 500 }}
								>
									Categories
								</Link>
							</Breadcrumbs>
						</Grid>
						<Grid item xs={12} lg={12}>
							<Typography variant='h6'>Categories</Typography>
							<Divider />
						</Grid>
						<Grid
							item
							xs={12}
							style={{ marginTop: matchesXS ? '-1em' : undefined }}
						>
							<Grid container>
								{newTags.map((tag, index) => {
									const [text, value] = tag
									const slug = slugify(text, { lower: true })
									return (
										<Grid item xs={6} key={index} style={{ padding: '.5em 0' }}>
											<Link
												to={`/articles/categories/${slug}`}
												className={darkMode ? classes.tags : classes.lightTags}
											>
												<Typography variant='body2'>
													{text} ({value})
												</Typography>
											</Link>
										</Grid>
									)
								})}
							</Grid>
							<Grid container style={{ paddingTop: '2em' }}>
								<PostsLists title={'All posts'} posts={posts} />
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Layout>
	)
}
